import BaseClient from '@/app/model/api/response/baseApiClient'

class WeedAlarmListApi extends BaseClient {
  public getWeedAlarmList () {
    const path = '/v1/weed-alarm'
    var url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new WeedAlarmListApi()
